// @flow

import alt from '../alt';

class ProductActions {
	uploadNcpFile(fileName: string, fileData: string, fileType: string): {...} {
		return {name: fileName, data: fileData, ncpType: fileType};
	}

	uploadGrFile(fileName: string, fileData: string): {...} {
		return {name: fileName, data: fileData};
	}
	
	calcPoints() {
		return null;
	}
	
	downloadGrFile() {
		return null;
	}
	
	mirror() {
		return null;
	}
	
	mirrorShape() {
		return null;
	}
	
	rotate() {
		return null;
	}
	
	rotate90() {
		return null;
	}
	
	changeValue(field: string, value: string, idx: string): {...} {
		return {
			field: field,
			value: value,
			idx: idx
		};
	}
	
	moveE(direction) {
		return direction;
	}

	moveP(direction) {
		return direction;
	}

    moveHud(direction) {
        return direction;
    }

    removeP() {
		return null;
	}

	assignP() {
		return null;
	}
	
	/**
	 * NCP info ja GR2 tooteinfo lugemine
	 */
	readProductData(code, type) {
		return {code: code, type: type};
	}
	
	/**
	 * NCP info ja GR2 tooteinfo salvestamine
	 */
	saveProductData(code) {
		return code;
	}
	
	/**
	 * NCP ja GR2 tooteinfo kustutamine serverist
	 */
	deleteProduct(code) {
		return code;
	}
	
	deleteProductFailed(error) {
		return error;
	}
	
	deleteProductDone() {
		return null;
	}
	
	/**
	 * Algatatakse toote laadimine serverist
	 */
	fetchProduct(code) {
		return code;
	}
	
	/**
	 * Toote laadimine ebaõnnestus
	 */
	fetchProductFailed(error) {
		return error;
	}
	
	/**
	 * Toode sai laetud
	 */
	fetchProductDone(data) {
		return data;
	}
	
	/**
	 * Toote salvestamine serverisse
	 */
	saveProduct(code) {
		return code;
	}
	
	/**
	 * Toote salvestamine ebaõnnestus
	 */
	saveProductFailed(error) {
		return error;
	}
	
	/**
	 * Toode sai salvestatud
	 */
	saveProductDone() {
		return null;
	}

	/**
	 * Algatatakse NCP faili laadimine serverist
	 */
	fetchNcp(code: string, type: string): {...} {
		return {code: code, type: type};
	}
	
	/**
	 * NCP faili laadimine ebaõnnestus
	 */
	fetchNcpFailed(response) {
		return response;
	}
	
	/**
	 * NCP fail sai laetud
	 */
	fetchNcpDone(response) {
		return response;
	}
	
	/**
	 * NCP faili salvestamine serverisse
	 */
	saveNcp() {
		return null;
	}
	
	/**
	 * NCP faili salvestamine ebaõnnestus
	 */
	saveNcpFailed(error) {
		return error;
	}
	
	/**
	 * NCP fail sai salvestatud
	 */
	saveNcpDone() {
		return null;
	}

	setSchema(schema) {
		return schema;
	}
}

export default alt.createActions(ProductActions);
